<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import UPDATE from '../components/page/update.vue'
  import Url from '@/views/mis/util/url'
  import Qs from 'qs'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    mounted(){
        this.dataChanage(Url.active.active.queryById,{id:this.$route.query.id},res => {
            if (res.code == 0){
               let type = res.result.type;
                this.dataChanage(Url.active.type.queryAll,{},res => {
                    if (res.code == 0){
                        let template = [];
                        for (const i in res.result) {
                           if (res.result[i].type == type) template = JSON.parse(res.result[i].detail);
                        }
                        if (!template || template.length <= 0) return;
                        let updateCols = [{ title: 'id', field: 'id',hidden:true}];
                        let tableCols = [];
                        for (const i in template){
                            //封装update属性
                            if (template[i].type == 0) updateCols.push({title:template[i].title, field:template[i].field});
                            else if(template[i].type == 1) updateCols.push({title:template[i].title, field:template[i].field,upload:true});
                            //封装table属性
                            if (template[i].type == 0) tableCols.push({title:template[i].title, field:template[i].field});
                            else if(template[i].type == 1) tableCols.push({title:template[i].title, field:template[i].field,render:(data,full)=>{return "<img width='100px' src='"+data+"'>"}});
                        }
                        this.updateData.cols = updateCols;
                        this.pageData.cols = tableCols;
                        this.pageData.cols.push({title:window.$t('mis.bt.operation'),btnClick:[{name:window.$t('mis.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},{name:window.$t('mis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"}]});
                        this.$refs.childTable.defaultGetData({id:this.$route.query.id});
                    }
                })
            }
        });

    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
            this.dataChanage(Url.active.active.delDetail,{id:this.$route.query.id,detailId:row.id},res => {
                this.$refs.childTable.defaultGetData({id:this.$route.query.id});
                if (res.code == 0){
                    this.$refs.childUpdate.close();
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data) {
          if ("查询" == clickName || window.$t('mis.bt.search') == clickName) {
              this.queryData = data;
              this.$refs.childTable.defaultQueryData(data);
          }else if(clickName == window.$t('mis.bt.add')) {
              this.$refs.childUpdate.open();
          }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
          //根据是否包含id更新还是添加
          this.dataChanage(Url.active.active.editDetail, {id:this.$route.query.id,detail:JSON.stringify(model)}, res => {
              this.$refs.childTable.defaultGetData({id:this.$route.query.id});
              if (res.code == 0) {
                  this.$refs.childUpdate.close();
                  this.$message.success("suc");
              } else {
                  this.$message.error(res.message);
              }
          });
      },
      dataChanage(url, option, suc, fail){
          this.axios.post(url, Qs.stringify(option || {})).then(res => {
              if (suc && (typeof suc == 'function')) suc(res);
          }).catch(res => {
              if (fail && (typeof fail == 'function')) fail(res);
          })
      }
    },
    data () {
      return {
        queryData:{id:this.$route.query.id},
        /*新增或更新*/
        updateData:{
          cols:[]
        },
        formData:{
            hasLable: true,
            cols:[
                {click:window.$t('mis.bt.add')},
            ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.active.queryDetail,
          isPage:false,
          sequence: true,
          cols: []
        }
      }
    }
  }
</script>
